import { render, staticRenderFns } from "./IconMagnifier.vue?vue&type=template&id=6b626ab8&"
import script from "./IconMagnifier.vue?vue&type=script&lang=js&"
export * from "./IconMagnifier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports